<mat-dialog-content class="h-[700px]">
    <div class="font-bold text-lg text-dat-grey-900 mb-6">
        {{ settings.title }}
    </div>
    <div class="text-sm">
        <p class="mb-6">
            {{settings.primarySection.description}} <span class="font-bold">for the specified
                timeframe.</span>
        </p>
        <div class="mb-6 ">
            <img [src]="settings?.primarySection?.image" [alt]="settings.primarySection.imageAlt" class="w-full" />
        </div>
    </div>
    <div class="bg-dat-grey-050 p-6">
        <div class="font-bold text-sm">
            {{settings?.secondarySection?.title}}
        </div>
        <div class="text-sm">
            <p>
                {{settings.secondarySection.description}}
            </p>
        </div>
        <div class="mt-6">
            <img [src]="settings?.secondarySection?.image" [alt]="settings.secondarySection.imageAlt" class="w-full"/>
        </div>
    </div>
    <div class="flex flex-row-reverse mt-4">
        <button (click)="close()" class="!text-white font-button ml-6 !py-[11px] !px-6 !bg-dat-blue-500 !uppercase !border-solid !border-[1px] !border-dat-blue-500 !rounded-[99px]">
            Close
        </button>
        <a [href]="settings.footerSection.link" target="_blank"
            class="!py-[11px] !px-6 bg-white !text-dat-blue-400 !uppercase !border-solid !border-[1px] !border-dat-blue-500 !rounded-[99px] font-button no-underline">
            faq article
        </a>
    </div>
</mat-dialog-content>